
import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Edit, Save, X, Network } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import WebhooksTab from './tabs/WebhooksTab';
import ApiKeysTab from './tabs/ApiKeysTab';

interface WebhooksApiSettingsProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const WebhooksApiSettings: React.FC<WebhooksApiSettingsProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  const [activeTab, setActiveTab] = useState("webhooks");
  
  return (
    <Card>
      <CardHeader className="pb-2 flex flex-row justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Webhooks & APIs</h2>
          <p className="text-muted-foreground">
            Configure webhooks and API integrations
          </p>
        </div>
        <div className="flex gap-2">
          {editing ? (
            <>
              <Button variant="outline" onClick={onEditToggle} className="gap-1">
                <X className="h-4 w-4" />
                Cancel
              </Button>
              <Button onClick={onSave} className="gap-1">
                <Save className="h-4 w-4" />
                Save Changes
              </Button>
            </>
          ) : (
            <Button variant="outline" onClick={onEditToggle} className="gap-1">
              <Edit className="h-4 w-4" />
              Edit
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid grid-cols-2 mb-6">
            <TabsTrigger value="webhooks" className="flex items-center gap-1">
              <WebhooksTab.Icon className="h-4 w-4" />
              Webhooks
            </TabsTrigger>
            <TabsTrigger value="apikeys" className="flex items-center gap-1">
              <ApiKeysTab.Icon className="h-4 w-4" />
              API Keys
            </TabsTrigger>
          </TabsList>
          
          <TabsContent value="webhooks" className="space-y-4">
            <WebhooksTab editing={editing} />
          </TabsContent>
          
          <TabsContent value="apikeys" className="space-y-4">
            <ApiKeysTab editing={editing} />
          </TabsContent>
        </Tabs>
        
        {!editing && (
          <div className="flex justify-center items-center mt-6">
            <Button variant="default" className="gap-2">
              <Network className="h-4 w-4" />
              Test API Connection
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default WebhooksApiSettings;
